import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import { dominioDemandaCirurgica } from '../../../config/database';

export default function QuantidadeDemandasCadastradas(props) {
  const [quantidadeDemandasCadastradas, setQuantidadeDemandasCadastradas] = useState();
  const [sparklineData, setSparklineData] = useState([]);

  const [options, setOptions] = useState({
    series: [],
    labels: [],
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    chart: {
      id: 'sparkline',
      type: 'area',
      sparkline: {
        enabled: true,
      },
    },
    stroke: {
      curve: 'straight',
    },
    colors: ['#2196F3'],
    tooltip: {
      enabled: true,
      fixed: {
        enabled: true,
        position: 'topRight', // topRight; topLeft; bottomRight; bottomLeft
      },
    },
    fill: {
      opacity: 0.3,
    },
    yaxis: {
      min: 0,
    },
    title: {
      text: '-',
      offsetX: 0,
      align: 'center',
      style: {
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#32428C',
      },
      floating: false,
    },
    markers: {
      size: 4,
      fillOpacity: 0,
      strokeColor: '#fff',
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
  });

  const { equipes, centrosCirurgicos, dataInicio, dataFim, eOnco } = props;

  const updateCharts = () => {
    const idsEquipes = equipes.map(equipe => {
      return equipe.id;
    });

    const idsCentrosCirurgicos = centrosCirurgicos.map(centroCirurgico => {
      return centroCirurgico.id;
    });

    const dados = {
      filtros: {
        equipes: idsEquipes?.length > 0 ? idsEquipes.join() : null,
        centrosCirurgicos: idsCentrosCirurgicos?.length > 0 ? idsCentrosCirurgicos.join() : null,
        dataInicio: new Date(dataInicio),
        dataFim: new Date(dataFim),
        eOnco,
      },
    };
    dominioDemandaCirurgica
      .post(`/api/listarQuantidadeDemandasCadastradas`, dados)
      .then(response => {
        const config = {
          series: [],
          labels: [],
          dataLabels: {
            enabled: false,
          },
          legend: {},
          title: {
            text: '-',
          },
          markers: {
            size: 4,
            fillOpacity: 0,
            strokeColor: '#fff',
            strokeWidth: 2,
            hover: {
              size: 7,
            },
          },
        };

        /* const dataInclusao = response.data.map(dataItem => {
          const dateFormatted = new Date(dataItem.data_inclusao);
          return getMonth(dateFormatted) + 1;
        });
        console.log(dataInclusao); */

        const sparklineConfig = response.data.map(dado => ({
          x: dado.data_inclusao,
          y: dado.quantidade_demanda,
        }));
        setSparklineData(sparklineConfig);

        const sum = response.data
          .map(dado => {
            return dado.quantidade_demanda;
          })
          .reduce((partialSum, a) => partialSum + a, 0);
        setQuantidadeDemandasCadastradas(sum);
        config.title.text = sum;
        setOptions(config);
      });
  };

  useEffect(() => {
    updateCharts();
  }, [equipes, centrosCirurgicos, dataInicio, dataFim, eOnco]);

  return (
    <Card style={{ height: 150, width: '100%' }}>
      <CardHeader
        align="center"
        title="Demandas Cadastradas"
        style={{
          backgroundColor: '#32428C',
          color: 'white',
          height: 45,
          fontSize: 14,
          fontWeight: 'bold',
        }}
        size="1"
        disableTypography
      />
      <CardContent>
        <Chart
          options={options}
          series={[{ data: sparklineData, name: 'Demanda(s)' }]}
          type="area"
          height={90}
        />
      </CardContent>
    </Card>
  );
}
